import {
  useDashboardJobs,
  useHirerAccount,
  useHirerContracts,
  useHiringAdvice,
  useTalentSearchContext,
} from 'src/modules/ApiClient';

export const useIsDashboardDataLoaded = (): boolean => {
  const { loading: loadingDashboardJobs } = useDashboardJobs();
  const { loading: loadingHirerAccount } = useHirerAccount();
  const { loading: loadingHirerContracts } = useHirerContracts();
  const { loading: loadingHiringAdvice } = useHiringAdvice();
  const { loading: loadingTalentSearchContext } = useTalentSearchContext();

  return !(
    loadingDashboardJobs ||
    loadingHirerAccount ||
    loadingHirerContracts ||
    loadingHiringAdvice ||
    loadingTalentSearchContext
  );
};
